import template from './children-allowed.jade';
import itemsYesNo from '../../../enums/yes-no';

export default angular
  .module('cian.addForm.childrenAllowed', ['cian.addForm.fieldTypeSwitcher'])
  .directive('cianAfAboutObjectChildrenAllowed', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller() {
      this.items = itemsYesNo;
      if (!this.ad.childrenAllowed && this.ad.category === 'roomRent' && this.items[1]) {
        this.ad.childrenAllowed = this.items[1].value;
      }
    },
    controllerAs: 'childrenAllowedCtrl',
    template,
  })).name;
